import React from 'react';
type BloomProps = {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
};
const sizes = {
  sm: 'h-56 w-56',
  md: 'h-80 w-80',
  lg: 'h-[28rem] w-[36rem]'
};

/** Soft blurred emerald glow used behind page and section titles. */
export function Bloom({
  className = '',
  size = 'md'
}: BloomProps) {
  return <div aria-hidden="true" className={`pointer-events-none absolute -z-10 rounded-full bg-emerald-500/15 blur-3xl ${sizes[size]} ${className}`} data-id="element-151" data-mp="vbg0xhn8wp1v" />;
}